/*! @pentacode/ui v0.1.0 */
import { activeIcon as e } from "./elements/icon/active-icon.js";
import "./icon-DW8BBY5W.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, state as u } from "lit/decorators.js";
import { ifDefined as d } from "lit/directives/if-defined.js";
// \0lit-plugin:css-sheet:./src/elements/menu/menu.css.js
var f = n(":host{gap:var(--_menu-group-gap);--_menu-item-gap:var(--menu-item-gap,.25em);--_menu-group-gap:var(--menu-group-gap,.5em);flex-direction:column;display:flex}:host([dividers]){gap:0}:host([hidden]){display:none}[part=group]{gap:var(--_menu-item-gap);flex-direction:column;display:flex}:host([dividers]) [part=group]{padding-block:var(--_menu-group-gap);border-block-end:solid 1px var(--menu-divider-color,var(--shade-2))}[part=heading]{opacity:var(--menu-heading-opacity,.75);align-items:center;gap:.25em;padding:.25em .5em;display:flex}[part=item]{padding:var(--menu-item-padding,.5em);border-radius:var(--menu-radius,var(--radius));color:var(--menu-color,currentColor);font:inherit;text-align:start;cursor:pointer;-webkit-user-select:none;user-select:none;touch-action:manipulation;appearance:none;background:0 0;border:0;align-items:center;gap:.25em;margin:0;display:flex}[part=item]:hover{box-shadow:inset var(--menu-hover,color-mix(in srgb, currentColor 6%, transparent)) 0 0 0 1000px}[part=item]:active{box-shadow:inset var(--menu-press,color-mix(in srgb, currentColor 12%, transparent)) 0 0 0 1000px}[part=item]:focus-visible{box-shadow:inset 0 0 0 .1em var(--menu-outline-color,var(--primary));outline:2px solid #0000}[part=item][active]{color:var(--menu-color-active,var(--primary));font-weight:700}[part=item]:disabled{opacity:var(--menu-opacity-disabled,.5);pointer-events:none}:host([icon-position=end]) [part=item] [part=icon]{opacity:.75;order:1}[part=label]{flex:1}"), p = class extends t(a) {
	constructor(...e) {
		super(...e), this.styles = f, this.groups = [], this.iconPosition = "start", this.dividers = !1, this._replaced = !1;
	}
	_onReplaceChange(e) {
		let t = e.currentTarget.assignedNodes({ flatten: !0 });
		this._replaced = t.some((e) => e.nodeType !== Node.TEXT_NODE || e.textContent?.trim());
	}
	_select(e) {
		this.dispatchEvent(new CustomEvent("menu-select", {
			detail: { id: e.id },
			bubbles: !0,
			composed: !0
		}));
	}
	_renderItem(t) {
		let n = t.id === this.active;
		return o`
            <button
                type="button"
                part="item"
                ?active=${n}
                ?disabled=${t.disabled}
                aria-current=${d(n ? "page" : void 0)}
                @click=${() => this._select(t)}
            >
                ${t.icon ? o`<ptc-ui-icon part="icon" name=${e(t.icon, n)}></ptc-ui-icon>` : s}
                <span part="label">${t.label}</span>
            </button>
        `;
	}
	render() {
		return o`
            <slot name="replace" @slotchange=${this._onReplaceChange}></slot>
            ${this._replaced ? s : this._renderGroups()}
        `;
	}
	_renderGroups() {
		return this.groups.map((e) => o`
                <div part="group" role="group" aria-label=${d(e.label)}>
                    ${e.label ? o`<div part="heading">
                              ${e.icon ? o`<ptc-ui-icon name=${e.icon}></ptc-ui-icon>` : s}
                              ${e.label}
                          </div>` : s}
                    ${e.items.map((e) => this._renderItem(e))}
                </div>
            `);
	}
};
i([l({ attribute: !1 }), r("design:type", Array)], p.prototype, "groups", void 0), i([l({ type: String }), r("design:type", String)], p.prototype, "active", void 0), i([l({
	type: String,
	reflect: !0,
	attribute: "icon-position"
}), r("design:type", String)], p.prototype, "iconPosition", void 0), i([l({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], p.prototype, "dividers", void 0), i([u(), r("design:type", Object)], p.prototype, "_replaced", void 0), p = i([c("ptc-ui-menu")], p);
export { p as t };

//# sourceMappingURL=menu-CH0wo0lM.js.map